var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"zelan-openapp",style:({bottom: _vm.bottom + 'rem'}),on:{"click":_vm.clickDownGuide}},[_vm._v("Open the "+_vm._s(_vm.appName)+" App")])
}
var staticRenderFns = []

export { render, staticRenderFns }